"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _button = require("../../button");

var _context = require("../../context");

var _icons = require("../../icons");

var _layout = require("../../layout");

var _screenReaderOnly = require("../../screen-reader-only");

var _utils = require("../../utils");

var _constants = require("../html/constants");

var _constants2 = require("../constants");

var _expandable = require("../expandable");

var _CardExpandableContent = _interopRequireDefault(require("./CardExpandableContent"));

var _CardExpandableTriggerButton = _interopRequireDefault(require("./CardExpandableTriggerButton"));

var _core = require("@emotion/core");

var _excluded = ["dataTestId", "onClick", "expandableContent", "expandableContentHasBackgroundColor", "expandableTriggerText", "shouldVisuallyHideTriggerText", "actionLabel", "disabled", "disabledActionLabel"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var CardItemContent = (0, _context.styledWithTheme)('div')(function (_ref) {
  var theme = _ref.theme,
      spacing = _ref.spacing;

  var _getPaddingForCard = (0, _expandable.getPaddingForCard)(theme, spacing),
      _getPaddingForCard2 = (0, _slicedToArray2.default)(_getPaddingForCard, 2),
      paddingVertical = _getPaddingForCard2[0],
      paddingHorizontal = _getPaddingForCard2[1];

  return {
    padding: "".concat(paddingVertical, "px ").concat(paddingHorizontal, "px")
  };
});
var CardItemBase = (0, _context.styledWithTheme)('li')(function (_ref2) {
  var theme = _ref2.theme,
      isClickable = _ref2.isClickable,
      disabled = _ref2.disabled;
  var clickableStyles = isClickable ? disabled ? {
    cursor: 'not-allowed'
  } : {
    cursor: 'pointer',
    ':hover': {
      outline: "".concat(_constants.ROW_HOVER_OUTLINE_WIDTH, "px solid ").concat(theme.selectors.color(_constants.ROW_HOVER_OUTLINE_COLOR)),
      outlineOffset: _constants.ROW_HOVER_OUTLINE_OFFSET
    }
  } : {};
  return _objectSpread(_objectSpread({}, clickableStyles), {}, {
    ':not(:last-of-type)': {
      borderBottom: "".concat(_constants.BORDER_WIDTH_INNER, "px solid ").concat(theme.selectors.color(_constants.BORDER_COLOR))
    },
    position: 'relative'
  });
});

var CardItem = function CardItem(_ref3) {
  var data = _ref3.data,
      index = _ref3.index,
      getRowAttributes = _ref3.getRowAttributes,
      isExpanded = _ref3.isExpanded,
      _toggleExpanded = _ref3.toggleExpanded,
      renderCardForRow = _ref3.renderCardForRow,
      spacing = _ref3.spacing;

  var attributes = _objectSpread(_objectSpread({}, _constants2.defaultRowAttributes), getRowAttributes({
    data: data,
    index: index
  }));

  var dataTestId = attributes.dataTestId,
      onClick = attributes.onClick,
      expandableContent = attributes.expandableContent,
      expandableContentHasBackgroundColor = attributes.expandableContentHasBackgroundColor,
      expandableTriggerText = attributes.expandableTriggerText,
      shouldVisuallyHideTriggerText = attributes.shouldVisuallyHideTriggerText,
      actionLabel = attributes.actionLabel,
      disabled = attributes.disabled,
      disabledActionLabel = attributes.disabledActionLabel,
      rest = (0, _objectWithoutProperties2.default)(attributes, _excluded);
  var dataTestProps = (0, _utils.buildDataTestProps)({
    dataTestComponent: 'StencilTableRow',
    dataTestId: dataTestId
  });

  var handleClick = function handleClick(event) {
    if (!!onClick && !disabled) {
      onClick({
        data: data,
        index: index,
        event: event
      });
    }
  };

  var handleActionButtonClick = function handleActionButtonClick(event) {
    if (!!onClick && !disabled) {
      event.stopPropagation();
      onClick({
        data: data,
        index: index,
        event: event
      });
    }
  };

  var hasExpandableContent = !!expandableContent && !disabled && !onClick;
  var accessibleIndex = index + 1;
  return (0, _core.jsx)(CardItemBase, (0, _extends2.default)({
    alignItems: "flex-start",
    onClick: handleClick,
    isClickable: !!onClick,
    disabled: disabled,
    "aria-label": hasExpandableContent ? accessibleIndex : undefined
  }, dataTestProps, rest), hasExpandableContent && (0, _core.jsx)(_CardExpandableTriggerButton.default, {
    isExpanded: isExpanded,
    toggleExpanded: function toggleExpanded() {
      return _toggleExpanded(index);
    },
    shouldVisuallyHideTriggerText: shouldVisuallyHideTriggerText,
    triggerText: "".concat(expandableTriggerText, ", ").concat(accessibleIndex)
  }), (0, _core.jsx)(CardItemContent, {
    spacing: spacing
  }, renderCardForRow({
    data: data,
    index: index
  }), !!onClick && (0, _core.jsx)(_react.default.Fragment, null, disabled ? (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, null, disabledActionLabel) : (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_layout.Spacer, {
    height: "S300"
  }), (0, _core.jsx)(_button.Button, {
    icon: (0, _core.jsx)(_icons.IconChevronRight, {
      size: _icons.IconSize.ExtraSmall,
      "aria-hidden": true
    }),
    iconPosition: _button.ButtonIconPosition.Trailing,
    size: _button.ButtonSize.Small,
    onClick: handleActionButtonClick
  }, actionLabel)))), hasExpandableContent && (0, _core.jsx)(_CardExpandableContent.default, {
    isExpanded: isExpanded,
    spacing: spacing,
    hasBackgroundColor: expandableContentHasBackgroundColor,
    data: data,
    index: index,
    expandableContent: expandableContent
  }));
};

var _default = CardItem;
exports.default = _default;